import React, { Suspense } from "react"

const NewFundLaunchWithModel = React.lazy(() => import("ipru_remote/HandOverNewFundLaunchModal"))

const NewFundLaunch = ({ isSticky = false }) => {
  return (
    <Suspense fallback={<div>Loading New Fund Launch...</div>}>
      <NewFundLaunchWithModel isSticky={isSticky} />
    </Suspense>
  )
}

export default NewFundLaunch
